import React, { useMemo, useCallback, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { TagService } from '../../../../../services/tag-service';
import { useUpdateBrandingContext } from '../context';
import CustomColorInput from '../custom-color-input';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import messages from './messages';
import style from './style.module.less';

const CustomColorPicker = ({ customBranding, disabled = false }) => {
  const { updateCustomBranding } = useUpdateBrandingContext();
  const [errorField, setErrorField] = useState();
  const availableColors = useMemo(() => TagService.getTagColors(), []);
  const {
    custom_color1: expectedDeliveryDate,
    custom_color2: trackingPageBackground,
    custom_color3: socialMediaColor,
    custom_colors: customColors,
  } = customBranding;

  const customColorValues = [
    {
      id: 'custom_color2',
      description: messages.trackingPageBackground,
      value: trackingPageBackground,
    },
    {
      id: 'custom_color1',
      description: messages.expectedDeliveryColor,
      value: expectedDeliveryDate,
    },
    {
      id: 'custom_color3',
      description: messages.socialMediaLinksColor,
      value: socialMediaColor,
    },
  ];

  const onValidateError = useCallback((hasError, field) => setErrorField(hasError ? field : ''), []);
  const updateColor = useCallback((field, hexColor) => updateCustomBranding(field, hexColor), [updateCustomBranding]);

  return (
    <div className={style['color-container']}>
      {customColorValues.map((customColor) => (
        <Fragment key={customColor.id}>
          <div
            className={classnames(style['color-element-label'], {
              [style['error-label']]: errorField === customColor.id,
            })}
          >
            <FormattedMessage {...customColor.description} />
          </div>
          <CustomColorInput
            availableColors={availableColors}
            field={customColor.id}
            onChange={updateColor}
            onValidateError={onValidateError}
            value={customColor.value}
          />
        </Fragment>
      ))}
      {(!customColors || disabled) && <div className={style['disabled-mask']} />}
    </div>
  );
};

CustomColorPicker.propTypes = {
  customBranding: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
};

export default CustomColorPicker;
